import { Box, styled, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { CollectionDto } from "../../services/generated.schemas";
import { filterOutSelectedProducts } from "../utils";
import ProductsGrid from "../general/ProductsGrid";

type MorePrintsProps = {
  selectedCollection: CollectionDto | undefined;
  selectedProductId: string | undefined;
};

const Wrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

const Title = styled(Typography)({
  color: "#AEAEAE",
  marginLeft: "2rem",
  marginTop: "clamp(0.5rem, 2vw, 1rem)",
  fontFamily: "Gantari, sans-serif",
  fontSize: "clamp(0.7rem, 2.5vw, 1.6rem)"
});

const MorePrints = ({
  selectedCollection,
  selectedProductId,
}: MorePrintsProps) => {
  const [products, setProducts] = useState(
    filterOutSelectedProducts(selectedCollection?.products, selectedProductId),
  );

  useEffect(() => {
    setProducts(
      filterOutSelectedProducts(
        selectedCollection?.products,
        selectedProductId,
      ),
    );
  }, [selectedCollection, selectedProductId]);

  return (
    <Wrapper>
      <Title variant="h5">MORE PRINTS</Title>
      <ProductsGrid collectionId={selectedCollection?.id} products={products} />
    </Wrapper>
  );
};

export default MorePrints;
